<template>
	<div class="search-container">
		<input
			type="search"
			:aria-label="ariaLabel"
			class="search-input"
			data-test="search-input"
			v-model="searchTerm"
			autocomplete="off"
			:placeholder="placeholder"
			@input="handleChange"
		/>
		<font-awesome-icon :icon="['far', 'search']" class="search-icon" />
	</div>
</template>

<script>
export default {
	name: 'SearchInput',
	props: {
		placeholder: String,
		ariaLabel: String,
	},
	data() {
		return {
			searchTerm: null,
		};
	},
	methods: {
		handleChange() {
			this.$emit('onSearchInputChange', this.searchTerm);
		},
	},
};
</script>

<style lang="scss" scoped>
.search-container {
	position: relative;

	.search-input {
		box-sizing: border-box;
		width: 100%;
		border-radius: 6px;
		border: 1px solid $border-color-light;
		@include rem('font-size', 16px);
		@include rem('padding', 12px 0 12px 36px);
	}

	.search-icon {
		position: absolute;
		@include rem('font-size', 18px);
		color: $brand-blue;
		left: 12px;
		top: 12px;
	}
}
</style>
